export enum ModalContentKey {
  COST_SUMMARY = 'cost-summary',
  PRODUCT_DESCRIPTION = 'product-description',
  REQUEST_QUOTATION = 'request-quotation',
  REQUEST_PDF = 'request-pdf',
  HELP = 'help',
  NONE = 'none',
}
